<a
  *ngIf="!!post"
  class="post-card__container block h-full p-[4px] bg-white! rounded-[6px]"
  [class.md:w-max-[192px]]="!small"
  [class.rotate-[4deg]]="rotate"
  [class.post-card__container--sm]="small"
  [routerLink]="`/post/${post.slug}`"
>
  <div class="post-card__content flex flex-col w-full h-full border-[0.5px] rounded-[2px]">
    <div class="w-full min-h-[150px] grow">
      <advanced-image [cldImg]="coverImg" [plugins]="coverImgPlugins" [alt]="post.title"></advanced-image>
    </div>

    <div
      class="pt-[16px] pb-[8px] px-[8px] relative flex items-center justify-center"
      [class.h-[56px]]="!small"
      [class.h-[54px]]="small"
    >
      <div
        *ngIf="post.level"
        class="post-card__level bg-white inline-flex items-center justify-center h-[24px] absolute top-[-12px] left-[50%] translate-x-[-50%] px-[8px] py-[2px] border-[0.58px] rounded-full"
      >
        <span *ngFor="let num of [].constructor(post.level.length); let i = index" class="text-[12px]">
          {{post.level.icon}}
        </span>
        <span *ngFor="let num of [].constructor(3 - post.level.length); let i = index" class="text-[12px] opacity-30">
          {{post.level.icon}}
        </span>
      </div>
      <h4 class="post-card__title text-[12px]/[10px] md:text-[14px]/[18px] text-center line-clamp-2">{{post.title}}</h4>
    </div>
  </div>
</a>
